












import { Vue, Component, Prop } from "vue-property-decorator";
import SessionDate from "../SessionDate.vue";

import {Element} from "@api/models/Element";
import { getDateByTimeZoneOffset } from "@common/dateTimeHelper";
import { RootState } from "@service/store/types/RootState";

@Component({
    components: { SessionDate }
})
export default class SessionListMainInfo extends Vue {

    @Prop({ required: true }) session: Element;
    @Prop({ default: false }) useSelectedTimeZone: boolean;

    get title() {
        return this.session.title || "";
    }

    get selectedTimeZoneOffset() {
        return (this.$store.state as RootState).selectedTimeZoneOffset;
    }

    get beginAt() {
        return this.useSelectedTimeZone ? getDateByTimeZoneOffset(this.session.beginAt, this.selectedTimeZoneOffset) : this.session.beginAt;
    }

    get endAt() {
        return this.useSelectedTimeZone ? getDateByTimeZoneOffset(this.session.endAt, this.selectedTimeZoneOffset) : this.session.endAt;
    }
}
